import {
    loginPointLabel,
    loginPoints
} from '../../../../components/sp-login-point/sp-login-point.enum';
import {
    loginTypeLabel,
    loginTypes
} from '../../../../components/sp-login-type/sp-login-type.enum';
import { roleTypeLabel, roleTypes } from '../../../../components/sp-role-type/sp-role-type.exports';

export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.roleType = roleTypes[0];
        this.roleTypeChanged();

        this.datepickerOptions = {maxDate: new Date()};

        this.loginPoints = loginPoints;

        this.loginTypes = loginTypes;

        this.roleTypes = roleTypes;

        const companyName = this.currentCompany.companyName;

        this.export = {
            template: 'administrators',
            get name() {
                return `${companyName}_SAASPASS_Statistics`;
            },
            fields: [
                'saaspassId',
                'displayName',
                'userIdentifyingName',
                'loginStatistic.loginType',
                'loginStatistic.loginPoint',
                'loginStatistic.loginService',
                'loginStatistic.sucessfulLogin',
                'loggedInOnDisplay',
            ],
        };
    }

    filterByDate() {
        const endDate = new Date(+this.endDate + 24 * 60 * 60 * 1000);
        const afterStart = log => this.startDate ? log.loggedInOn > this.startDate : true;
        const beforeEnd = log => this.endDate ? log.loggedInOn < endDate : true;
        this.filteredLogs = this.logs.filter(log => afterStart(log) && beforeEnd(log));
    }

    open($event, type) {
        $event.preventDefault();
        $event.stopPropagation();
        if (type === 1) {
            this.opened = true;
            this.opened1 = false;
        } else {
            this.opened1 = true;
            this.opened = false;
        }
    };

    getLoginSourceTooltip(log) {
        const {loginClient, loginClientOs, loginIp} = log;
        return [loginClient, loginClientOs, loginIp && `IP: ${loginIp}`].filter($ => $).join(' - ');
    }

    getLoginToTooltip(log) {
        const {loginService, appType, username} = log;
        return [loginService, appType, username].filter($ => $).join(' - ');
    }

    loginPointLabel(loginPoint) {
        return loginPointLabel(loginPoint);
    }

    loginTypeLabel(loginType) {
        return loginTypeLabel(loginType);
    }

    roleTypeChanged() {
        this.logs$[this.roleType]
            .get()
            .then(logs => {
                this.logs = logs;
                this.filterByDate();
                const format = date => new Date(date).toString().slice(4, 24);
                this.logs.forEach(log => log.loggedInOnDisplay = format(log.loggedInOn));
            })
    }

    roleTypeLabel(roleType) {
        return roleType ? roleTypeLabel(roleType) : 'global.filter.all';
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/reports/administrator-audit/administrator-audit.controller.js